import { ApiResponse, BaseCreateResponse, BaseInfo, BaseResponse, baseUrl, deleteWithAuth, deleteWithBodyAndAuth, getWithAuth, Guid, ListRespone, postWithAuth } from "./baseApi"



export type CreateTagRequest = {
    name : string,
}

export type TagManagmentGetRequest = {
    searchString: string,
    playerIds: Guid[],
    campaignIds: Guid[],
    streamIds: Guid[],
    playNowIds: Guid[]
}

export type ExtendedBaseInfo = BaseInfo & {
    isAny?: boolean;
}

export type TagManagmentProfile = {
    name:string,
    id:string,
    players: BaseInfo[],
    campaigns: BaseInfo[],
    includedStreams: ExtendedBaseInfo[],
    excludedStreams: BaseInfo[],
    includedPlayNows: ExtendedBaseInfo[],
    excludedPlayNows: BaseInfo[]
}

export enum TagManagmentEntityType {
    Players = 1,
    Campaigns = 2,
    IncludedStreams = 3,
    ExcludedStreams = 4,
    IncludedPlayNows = 5,
    ExcludedPlayNows = 6
}

export type TagManagmentEntityRequest = {
    entityType: TagManagmentEntityType,
    entityId: Guid,
    tagId: Guid
}

export const getTags = async () : Promise<ApiResponse<ListRespone<BaseInfo>>> => {
    return await getWithAuth<ListRespone<BaseInfo>>({url : `${baseUrl}tag`});
}

export const createTag = async (request : CreateTagRequest) : Promise<ApiResponse<BaseCreateResponse>> => {
    return await postWithAuth<CreateTagRequest,BaseCreateResponse>(`${baseUrl}tag`, request);
}

export const getTagManagment = async (request : TagManagmentGetRequest) : Promise<ApiResponse<ListRespone<TagManagmentProfile>>> => {
    return await postWithAuth<TagManagmentGetRequest,ListRespone<TagManagmentProfile>>(`${baseUrl}tag/managment`, request);
}

export const updateTag = async(id:Guid, request: CreateTagRequest) : Promise<ApiResponse<BaseCreateResponse>> => {
    return await postWithAuth<CreateTagRequest,BaseCreateResponse>(`${baseUrl}tag/${id}`, request)
} 

export const deleteTag = async (id: Guid) : Promise<ApiResponse<BaseResponse>> => {
    return await deleteWithAuth<BaseResponse>(`${baseUrl}tag`, id)
}

export const deleteTagManagmentEntity = async (request: TagManagmentEntityRequest) : Promise<ApiResponse<BaseResponse>> => {
    return await deleteWithBodyAndAuth<TagManagmentEntityRequest, BaseResponse>(`${baseUrl}tag/remove-tag`, request)
}

export const addEntityForTag = async(request: TagManagmentEntityRequest) : Promise<ApiResponse<BaseCreateResponse>> => {
    return await postWithAuth<TagManagmentEntityRequest,BaseCreateResponse>(`${baseUrl}tag/add-tag`, request)
} 

export const getTagStreams = async () : Promise<ApiResponse<ListRespone<BaseInfo>>> => {
    return await getWithAuth<ListRespone<BaseInfo>>({url : `${baseUrl}tag/streams`});
}